export { AgileHeading, type AgileHeadingProps } from "./agile-heading";
export { AgileHeading as default } from "./agile-heading";
